var React = require('react');

function Invites (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"20","height":"15","rx":"1","stroke":"#FFD25D","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M11.5 9L2.62875 1.52947C2.41471 1.34923 2.54217 1 2.82199 1H20.178C20.4578 1 20.5853 1.34923 20.3713 1.52947L11.5 9Z","stroke":"#FFD25D","strokeWidth":"2","key":1})]);
}

Invites.defaultProps = {"width":"20","height":"17","viewBox":"0 0 23 17","fill":"none"};

module.exports = Invites;

Invites.default = Invites;
